import { useEffect, useState, useRef } from 'react';
import styles from './BureauEnquiryDrawer.module.scss';
import SideDrawer from '../../../../../../../common/_custom/SideDrawer/SideDrawer';
import BureauEnquiryTable from './BureauEnquiryTable/BureauEnquiryTable';
import { useAppDispatch } from '../../../../../../../app/hooks';
import { useSearchParams } from 'react-router-dom';
import { fetchBureauEnquiryData } from '../../../../../../../store/dashboard/creditBureau/actions';
import { VendorType, EnquiryData } from '../CreditBureauConstants';
import { Mixpanel } from '../../../../../../../utils/mixpanel';
import { AICA_LIST_PAGE_VIEW_BUREAU_ENQUIRY_DRAWER } from '../../../../../../../utils/constants/mixpanelEvents/investorEvents';

type BureauEnquiryDrawerProps = {
    onClose?: () => void;
    directorId?: string;
    vendorType?: VendorType;
};

function BureauEnquiryDrawer({ onClose, directorId, vendorType }: BureauEnquiryDrawerProps) {
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState(false);
    const [enquiryData, setEnquiryData] = useState<EnquiryData[]>([]);
    const [searchParams] = useSearchParams();
    const bureauTypeFromParams = searchParams.get('vendorTypeEnquiryDrawer') as VendorType;
    const directorIdFromParams = searchParams.get('directorIdEnquiryDrawer');
    const mountTimeRef = useRef<number | null>(null);

    useEffect(() => {
        // Record the mount time
        mountTimeRef.current = Date.now();
        const effectiveDirectorId = directorId || directorIdFromParams;
        if (effectiveDirectorId) {
            fetchEnquiryData(effectiveDirectorId);
        }
        return () => {
            // On unmount, calculate duration and send to Mixpanel
            if (mountTimeRef.current) {
                const durationMs = Date.now() - mountTimeRef.current;
                Mixpanel.track(AICA_LIST_PAGE_VIEW_BUREAU_ENQUIRY_DRAWER, {
                    duration_seconds: durationMs / 1000,
                    directorId: effectiveDirectorId,
                    vendorType: vendorType || bureauTypeFromParams,
                });
            }
        };
    }, [directorId, directorIdFromParams, bureauTypeFromParams, vendorType]);

    const getDrawerHeader = () => {
        const displayVendorType = vendorType || bureauTypeFromParams;
        const formattedVendorType = displayVendorType
            ? displayVendorType.charAt(0).toUpperCase() + displayVendorType.slice(1).toLowerCase()
            : '';

        return (
            <div className={styles.DrawerHeaderContent}>
                <div className={styles.DrawerHeaderContentText}>Bureau Enquiry</div>
                <div className={styles.DrawerHeaderContentSubText}>{formattedVendorType}</div>
            </div>
        );
    };

    const fetchEnquiryData = (id: string) => {
        setLoading(true);
        dispatch(
            fetchBureauEnquiryData(
                { requestPayload: { directorId: id, bureauName: vendorType || bureauTypeFromParams } },
                {
                    onSuccess: (data) => {
                        setLoading(false);
                        setEnquiryData(data);
                    },
                    onError: () => {
                        setLoading(false);
                    },
                },
            ),
        );
    };

    return (
        <SideDrawer onClose={onClose} showHeading heading={getDrawerHeader()} width="800px">
            <div className={styles.BureauEnquiryDrawerContainer}>
                <BureauEnquiryTable data={enquiryData} loading={loading} vendorType={vendorType || bureauTypeFromParams} />
            </div>
        </SideDrawer>
    );
}

export default BureauEnquiryDrawer;
